import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { VersionService } from '@app/services/version.service';
import { TranslocoPipe } from '@jsverse/transloco';
import { Button } from 'primeng/button';

@Component({
  selector: 'app-update-hint',
  standalone: true,
  imports: [CommonModule, TranslocoPipe, Button],
  template: `
    @if (versionService.updateAvailable()) {
      <div class="mx-4 my-4 rounded-lg border border-primary-500 bg-primary-50 px-2 py-4 md:mx-8">
        <p class="mb-4 pl-1 font-bold">{{ 'version.updateAvailable.title' | transloco }}</p>
        <div class="flex flex-col justify-start gap-2 md:flex-row md:items-center">
          <p-button
            styleClass="!bg-white max-md:w-full"
            severity="secondary"
            [outlined]="true"
            (onClick)="versionService.dismiss()"
            [label]="'version.updateAvailable.btn.dismiss' | transloco" />
          <p-button styleClass="max-md:w-full" (click)="versionService.update()">{{ 'version.updateAvailable.btn.updateNow' | transloco }}</p-button>
        </div>
      </div>
    }
  `,
})
export class UpdateHintComponent {
  versionService = inject(VersionService);
}
